module.exports = __webpack_public_path__ + "static/media/ARI-STEVI Smart 450-451.d0b6a002.jpg";